import React from "react";
import MiniHero from "components/miniHero";

const Schedule: React.FC = () => {
  return (
    <div>
      <MiniHero image="/images/Gallery/DSC09989.jpg" text="Schema" />

      {/* Main Content Section */}
      <div className="container mx-auto mt-8 px-8 lg:px-20 py-8">
        <div className="flex flex-col items-center gap-16">
          {/* Left Column - Text Content */}
          <div className="w-full md:w-3/4 text-left">
            {/* Heading */}
            <h1
              className="text-4xl font-bold text-gray-800 mb-6"
              style={{ fontFamily: "'Bebas Neue', sans-serif" }}
            ></h1>

            {/* Introduction */}
            <p
              className="text-lg text-gray-600 mb-6"
              style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            >
              Här hittar du våra aktuella tider för gruppträning och information
              om hur du kan boka både gruppträning och massage. Våra pass är
              utformade för att vara tillgängliga för alla och anpassade för att
              möta dina behov.
            </p>

            {/* Group Training Schedule */}
            <div className="mb-8">
              <h2
                className="text-2xl font-semibold text-gray-800 mb-4"
                style={{ fontFamily: "'Bebas Neue', sans-serif" }}
              >
                Gruppträningsschema
              </h2>
              <ul
                className="list-disc list-inside text-lg text-gray-600"
                style={{ fontFamily: "'IBM Plex Mono', monospace" }}
              >
                <li>
                  <strong>Måndag:</strong> 18:00–19:00
                </li>
                <li>
                  <strong>Torsdag:</strong> 18:00–19:00
                </li>
                <li>
                  <strong>Söndag:</strong> 17:00–18:00
                </li>
              </ul>
              <p
                className="text-lg text-gray-600 mt-4"
                style={{ fontFamily: "'IBM Plex Mono', monospace" }}
              >
                Våra gruppträningar fokuserar på funktionell träning och passar
                både nybörjare och erfarna deltagare. Vi ser till att varje pass
                är roligt, varierande och effektivt.
              </p>
            </div>

            {/* Booking Information */}
            <div className="mb-8">
              <h2
                className="text-2xl font-semibold text-gray-800 mb-4"
                style={{ fontFamily: "'Bebas Neue', sans-serif" }}
              >
                Boka Gruppträning och Massage
              </h2>
              <p
                className="text-lg text-gray-600"
                style={{ fontFamily: "'IBM Plex Mono', monospace" }}
              >
                För att boka gruppträning eller massage, vänligen besök vår
                bokningssida på{" "}
                <a
                  href="https://www.bokadirekt.se/places/lada-basteskar-60229"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  Boka Direkt
                </a>
                . Där hittar du all tillgänglig information om tider och
                tjänster.
              </p>
            </div>

            {/* Call-to-Action */}
            <div
              className="text-center my-16"
              style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            >
              <a
                href="https://www.bokadirekt.se/places/lada-basteskar-60229"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-darkBlue text-white font-semibold py-3 px-8 rounded-md hover:bg-hoverBlue transition duration-200"
              >
                Boka Nu
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Schedule;
